import { ISkillLevelResource } from "../../skill-levels";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillLevelTranslationResource } from "../types";

export type ISkillLevelTranslationQueryParameters = {
    skillLevel?: RelationalValue<ISkillLevelResource>;
    locale?: string;
};

export type ISkillLevelTranslationQueryResult = ISkillLevelTranslationResource;

export const skillLevelTranslationQuery: IApiQueryFunction<ISkillLevelTranslationQueryParameters> = ({
    skillLevel,
    locale,
}) => {
    if (!skillLevel || !locale) {
        return;
    }

    return {
        method: "GET",
        url: `/skill_levels/${mapRelationalValue(skillLevel)}/translations/${locale}`,
    };
};

export const useSkillLevelTranslationQuery = createApiQueryHook<
    ISkillLevelTranslationQueryParameters,
    ISkillLevelTranslationQueryResult
>(skillLevelTranslationQuery);
